import { BorderOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation';
import React from 'react';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { CommonGraphicWidgetConfigSchema } from '../common/CommonGraphicWidgetConfigSchema';
import { PdfElementConfigAlert } from '../common/PdfElementConfigAlert';
import { IPageBreakWidget } from './IPageBreakWidget';
import { PageBreakPreviewComponent } from './PageBreakPreviewComponent';
import { PageBreakWidgeComponent } from './PageBreakWidgeComponent';

export const PageDividerWidgetConfigSchema: yup.ObjectSchema<IPageBreakWidget> =
  CommonGraphicWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.PageBreak).required(),
  })
    .required()
    .noUnknown();

/**
 * Tipo del componente di visualizzazione di un divisore per il titolo.
 */
export const PageBreakWidgetType: IWidgetType<IPageBreakWidget> = {
  type: WidgetType.PageBreak,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Interruzione di Pagina',
  icon: <BorderOutlined />, // TODO change icon
  hasValue: false,
  formComponent: PageBreakWidgeComponent,
  configComponent: PdfElementConfigAlert,
  configValidator: PageDividerWidgetConfigSchema,
  previewComponent: PageBreakPreviewComponent,
  translationSchema: tran.widget({}),
  configOptions: {
    removeCollapsePanel: true,
  },
  rules: [],
};
